export default __webpack_public_path__ + "1420e518f1beefa71ccc1dc9c0fa51e9.svg";